import { __ } from "@wordpress/i18n";
import { COMPARE_FIELDS_OPTIONS } from "../constants";

const LoadingSkeleton = ({ compareFields }) => {
  return (
    <div className="brandy-compare-table skeleton-table">
      <div className="compare-table-container">
        <table className="compare-table">
          <tbody>
            {Object.keys(COMPARE_FIELDS_OPTIONS).map((fieldKey) => {
              const fieldLabel = COMPARE_FIELDS_OPTIONS[fieldKey];
              if (!fieldLabel) return null;

              return (
                <tr
                  key={fieldKey}
                  className={`compare-row compare-row-${fieldKey} skeleton-row`}
                >
                  <td className="compare-field-label">
                    <strong>{fieldLabel}</strong>
                  </td>
                  {/* Render skeleton cells for 3 columns */}
                  {[1, 2, 3].map((index) => (
                    <td
                      key={index}
                      className="compare-product-cell skeleton-cell"
                    >
                      {renderSkeletonField(fieldKey)}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const renderSkeletonField = (fieldKey) => {
  switch (fieldKey) {
    case "name":
      return (
        <div className="skeleton-field skeleton-name">
          <div className="skeleton-line skeleton-line-short"></div>
        </div>
      );

    case "image":
      return (
        <div className="skeleton-field skeleton-image">
          <div className="skeleton-image-placeholder"></div>
        </div>
      );

    case "description":
      return (
        <div className="skeleton-field skeleton-description">
          <div className="skeleton-line"></div>
          <div className="skeleton-line skeleton-line-short"></div>
        </div>
      );

    case "price":
      return (
        <div className="skeleton-field skeleton-price">
          <div className="skeleton-line skeleton-line-medium"></div>
        </div>
      );

    case "rating":
      return (
        <div className="skeleton-field skeleton-rating">
          <div className="skeleton-stars">
            <div className="skeleton-star"></div>
            <div className="skeleton-star"></div>
            <div className="skeleton-star"></div>
            <div className="skeleton-star"></div>
            <div className="skeleton-star"></div>
          </div>
        </div>
      );

    case "add_to_cart":
      return (
        <div className="skeleton-field skeleton-button">
          <div className="skeleton-button-placeholder"></div>
        </div>
      );

    default:
      return (
        <div className="skeleton-field">
          <div className="skeleton-line"></div>
        </div>
      );
  }
};

export default LoadingSkeleton;
